import { defineMessages } from "react-intl";

export const messages = defineMessages({
  leaveCallTooltip: {
    id: "video.toolbar.leaveCall.tooltip",
    defaultMessage: "End call for all",
    description: "Tooltip label for button leave call",
  },
  dialogTitle: {
    id: "dialog.leaveMeeting.title",
    defaultMessage: "Do you want to leave this meeting?",
    description: "Dialog title",
  },
  dialogSubmitButton: {
    id: "dialog.leaveMeeting.button.submit",
    defaultMessage: "Leave meeting",
    description: "Dialog submit button",
  },
  dialogCancelButton: {
    id: "dialog.leaveMeeting.button.cancel",
    defaultMessage: "Cancel",
    description: "Dialog cancel button",
  },
});
